import { Group } from '@app/tool/model/group.model';
import { PagedResponse } from '@models/response.model';

export class Batch {
    public id: number;
    public name: string;
    public tools: PagedResponse<Group[]>;

    constructor(slot: any = {}) {
        this.id = slot.id || 0;
        this.name = slot.name || '';
        this.tools = slot.tools ? slot.tools : [];
    }

    get type() {
        return 'slot';
    }
}
